module.exports = __webpack_public_path__ + "static/img/边框10.84064cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框10.svg
// module id = lIDM
// module chunks = 2